import React, {useState} from 'react';
import { addStuffs } from '../../api/Stuffs';
import { registerUsers } from '../../api/Auth';
import { useNavigate } from 'react-router-dom';

function UserForm() {
    const history = useNavigate();
    const [isloading, setLoading] = useState(false)
    const [stuffData, setStuffData] = useState({
        name : "",
        username : "",
        departiment : "",
        password1 : "",
        password2 : "",
        email : "",
        role : "",
        mobile : "",
        address : "",
        city : "",
        country : "",
    });

   const {name, username, departiment, password1, password2, email, role, mobile, address, city, country} = stuffData;
          function handleName(e){
              setStuffData({...stuffData, name : e.target.value});
          }
          function handleUsername(e){
              setStuffData({...stuffData, username : e.target.value});
          }
          function handleDepatiment(e){
              setStuffData({...stuffData, departiment :  e.target.value});
          }
          function handlePassword(e){
              setStuffData({...stuffData, password1 : e.target.value});
          }
          function handlePassword2(e){
            setStuffData({...stuffData, password2 : e.target.value});
        }
          function handleEmail(e){ 
            setStuffData({...stuffData, email : e.target.value});
          }
          function handleRole(e){
              setStuffData({...stuffData, role : e.target.value});
          }
          function handleMobile(e){
              setStuffData({...stuffData, mobile : e.target.value});
          }
          function handleAddress(e){
              setStuffData({...stuffData, address : e.target.value});
          }
          function handleCity(e){
              setStuffData({...stuffData, city : e.target.value});
          }
          function handleCountry(e){
             setStuffData({...stuffData, country : e.target.value});
          }

         
            function handleSubmit(e){
                e.preventDefault();
                  if(name.length < 1){
                     e.preventDefault();
                    return alert("Full Name is required");
                  }
                  if(username.length < 1){
                     e.preventDefault();
                    return alert("Username is required");
                  }
                  if(departiment.length < 1){
                     e.preventDefault();
                    return alert("Departiment is required");
                  }
                  if(password1.length < 1){
                     e.preventDefault();
                    return alert("Password is required");
                  }
                  if(password2.length < 1){
                     e.preventDefault();
                    return alert("Please confirm password is required");
                  }
                  if(email.length < 1){
                       e.preventDefault();
                      return alert("Email Address is required");
                  }
                  if(role.length < 1){
                       e.preventDefault();
                      return alert("Stuff Role is required");
                  }
                  if(mobile.length < 1){
                       e.preventDefault();
                      return alert("Mobile number is required");
                  }
                  if(address.length < 1){
                       e.preventDefault();
                      return alert("Address is required");
                  }
                  if(city.length < 1){
                       e.preventDefault();
                      return alert("City is required");
                  }
                  if(country.length < 1){
                     e.preventDefault();
                    return alert("Country is required");
                  }
                    //check if the password is equal
                    if(password1 !== password2){
                        e.preventDefault();
                       return alert("Password did not match!");    
                    }

                  const userRegData = {
                        email,
                        username,
                        password1,
                        password2,
                        role : role,
                  };
                

                  const stuffData = {
                      name,
                      departiment,
                      email,
                      mobile,
                      address,
                      city,
                      country
                  }

                  addStuffs(stuffData, (result) =>{
                    setLoading(true)
                        if(result.ok === 1){
                           registerUsers(userRegData, (result) =>{
                                 if(result.ok === 1){
                                    alert("Stuff Member registered Successful!");
                                    setLoading(false);
                                    return history("/Users-List");
                                 }
                           })
                        }else{
                            return alert("Intenal Server Error Occured!");
                        }
                  })



                  
            }



    return ( 
        <div className='container'>
            <div className='row justify-content-center'>
                <div className='row'>
                    <div className='col md-12'>
                                  <h5 className='m-3'>Add-User</h5>
                               <form method='post'>
                               {/* <div className='row'>
                                    <div className='col md-6'>
                                        <div className='form-group'>
                                            <label>Profile</label>
                                            <input type='file' className='form-control'/>
                                        </div>
                                    </div>
                                    <div className='col md-6'></div>
                                </div> */}
                                <div className='row'>
                                    <div className='col md-6'>
                                    <div className='form-group'>
                                            <label>Full Name</label>
                                            <input type='text' onChange={handleName} name='name' className='form-control'/>
                                        </div>
                                    </div>
                                    <div className='col md-6'>
                                    <div className='form-group'>
                                            <label>Username</label>
                                            <input type='text' onChange={handleUsername} name='username' className='form-control'/>
                                        </div>
                                    </div>
                                </div>
                                <div className='row'>
                                    <div className='col md-6'>
                                        <div className='form-group'>
                                            <label>Departiment</label>
                                            <select name='departiment' onChange={handleDepatiment} className='form-control'>
                                                <option>----</option>
                                                <option>Accountant</option>
                                                <option>Audit</option>
                                            </select>
                                        </div>
                                    </div>
                                    <div className='col md-3'>
                                        <div className='form-group'>
                                            <label>Password</label>
                                            <input name='password1' onChange={handlePassword} type='password' className='form-control'/>
                                        </div>
                                    </div>
                                    <div className='col md-3'>
                                        <div className='form-group'>
                                            <label>Confirm Password</label>
                                            <input name='password2' onChange={handlePassword2} type='password' className='form-control'/>
                                        </div>
                                    </div>
                                </div>
                                <div className='row'>
                                    <div className='col md-6'>
                                        <div className='form-group'>
                                            <label>Email</label>
                                            <input type='text' onChange={handleEmail} name='email' className='form-control'/>
                                        </div>
                                    </div>
                                    <div className='col md-6'>
                                        <div className='form-group'>
                                            <label>Role</label>
                                            <select name='role' onChange={handleRole} className='form-control'>
                                                <option>----</option>
                                                <option>Stuff</option>
                                                <option>Admin</option>
                                            </select>
                                        </div>
                                    </div>
                                </div>
                                <div className='row'>
                                    <div className='col md-6'>
                                        <div className='form-group'>
                                            <label>Phone Number</label>
                                            <input name='mobile' onChange={handleMobile} type='text' className='form-control'/>
                                        </div>
                                    </div>
                                    <div className='col md-6'>
                                        <div className='form-group'>
                                            <label>Adress</label>
                                            <input name='address' onChange={handleAddress} type='text' className='form-control'/>
                                        </div>
                                    </div>
                                </div>
                                <div className='row'>
                                    <div className='col md-6'>
                                        <div className='form-group'>
                                            <label>City</label>
                                            <input name='city' onChange={handleCity} type='text' className='form-control'/>
                                        </div>
                                    </div>
                                    <div className='col md-6'>
                                        <div className='form-group'>
                                            <label>Coutry</label>
                                            <input name='country' onChange={handleCountry} type='text' className='form-control'/>
                                        </div>
                                    </div>
                                </div>
                                
                                <div className='row mt-3'>
                                    <div className='col md-12'>
                                       <button onClick={handleSubmit} className='btn btn-dark btn-md'>Submit</button>
                                    </div>
                                   
                                </div>

                               </form>


                            </div>
                        </div>
                    </div>
                   </div>
     );
}

export default UserForm;